module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "BusinessHallView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BusinessHallView!./src/pages/Promote/BusinessHall/IdNumberVerification/index.js
// module id = 2071
// module chunks = 367